module.exports = __webpack_public_path__ + "static/media/contactusIcon.86a0dba4.svg";